export const serviceProviderSelector = (state) => {
  if(!state.FilterServiceProviderandPropertyDeveloperList?.payload){
    return []
  }
  return state.FilterServiceProviderandPropertyDeveloperList.payload.reduce(
    (filtered, contact) => {
      if (contact.role === "Service Provider") {
        filtered.push({
          value: contact.id,
          label: contact.firstname + " " + contact.lastname,
        });
      }
      return filtered;
    },[]
  );
}